import TrailPageType from '@alltrails/amplitude/enums/TrailPageType';
import TrailDetails from '@alltrails/types/TrailDetails';

const getTrailPageType = (trailDetails: TrailDetails): TrailPageType => {
  if (Boolean(trailDetails.childTrails?.length)) {
    return 'multi day route page';
  }
  if (Boolean(trailDetails.parentTrails?.length)) {
    return 'segment page';
  }
  return 'trail detail page';
};

export default getTrailPageType;
